/**
 * UserProfile Component
 */

import * as React from 'react';
import * as BEM from 'react-bem-helper';
import { connect } from 'react-redux';

import { IconUser } from '../../../atoms/images/Icon';
import Thumbnail from '../../../atoms/images/Thumbnail';

interface IOwnStateProps {
  logoutUrl?: string;
}

interface IOwnProps {
  profile: GQL.IProfile | null;
}

interface IFacebookPictureProps {
  data: {
    url: string;
  };
}

type UserProfileProps = IOwnProps & IOwnStateProps;

const classes = new BEM('user-profile');

class UserProfile extends React.Component<UserProfileProps, {}> {

  render() {
    const {
      profile,
    } = this.props;

    const {
      external_provider,
      picture,
    } = profile!;

    let profilePicture = picture;

    if (external_provider === 'Facebook' && profilePicture) {
      const facebookProfilePictureJson = JSON.parse(profilePicture);
      if (facebookProfilePictureJson.hasOwnProperty('data')) {
        profilePicture = (facebookProfilePictureJson as IFacebookPictureProps).data.url;
      } else if (facebookProfilePictureJson.hasOwnProperty('source')) {
        profilePicture = facebookProfilePictureJson.source;
      } else {
        profilePicture = null;
      }
    }

    return (
      <>
        {!!profilePicture ?
          <Thumbnail src={profilePicture} size="xsmall" shape="circle" {...classes('')} />
          : <IconUser />
        }
      </>
    );
  }
}

const ConnectedUserProfile = connect(
  ({ authentication }: IStoreState, ownProps: IOwnProps): IOwnStateProps => ({
    logoutUrl: authentication.logoutUrl,
  }),
)(UserProfile);

export default ConnectedUserProfile;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/public/components/organisms/global/AppNavigation/UserProfile.tsx